import React from 'react';

import {IEntityMeta} from 'entities/metadata';
import {selectDashboardEntityData} from 'modules/data/data-selectors';
import {IEntityData} from 'modules/data/data-types';
import {useAppSelector} from 'store/config/hooks';

import {DashboardComponent} from './dashboard-component/dashboard-component';

import './dashboard.less';

export interface IDashboardProps {
    entityName: string;
    meta?: IEntityMeta;
    context?: IEntityData;
}

export const Dashboard = ({entityName, meta, context}: IDashboardProps) => {
    const data = useAppSelector(selectDashboardEntityData(entityName));

    return meta?.fields ? (
        <div className="dashboard">
            {meta?.fields.map(field => (
                <DashboardComponent
                    key={field.key}
                    entityName={entityName}
                    meta={field}
                    data={data ? data[field.key] : undefined}
                    context={context}
                />
            ))}
        </div>
    ) : <></>;
};
